module.exports = __webpack_public_path__ + "img/Avihu Levy.e1934460.jpg";